<template>
  <div class="container">
    <div class="content-wrapper">
      <h2>Dziękujemy za doładowanie!</h2>
      <div class="payment-info">
        <topup-loader v-if="isLoading" :is-back="true" />
        <div v-if="!isLoading">
          <div v-if="isTopupOk()">
            <h2>Twoja płatność została zrealizowana.</h2>
          </div>
          <div v-if="isTopupError()">
            <h2>Niestety nie udało się zrealizować płatności.</h2>
          </div>
          <div class="payment-info-buttons">
            <div class="button" v-if="!backUrl">
              <button type="button" id="topup-again" class="btn btn-primary" @click="goToTopup">Doładuj ponownie <i class="icon icon-middle icon-arrow-right" /></button>
            </div>
            <div class="button" v-if="backUrl">
              <button type="button" class="btn btn-primary" @click="goBack">Dalej <i class="icon icon-middle icon-arrow-right" /></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopupBackMixin from '@/common/mixins/views/TopupBack.mixin'
import TopupLoader from '@/pge/components/Topup/Loader'
import { mapActions, mapState } from 'vuex'
import { ROUTING } from '@/pge/const/routing.const'
import { TOPUP_PAYMENT_STATUS } from '@/common/const/topup.const'
import { Raven } from 'vue-raven'

export default {
  name: 'TopupBackView',
  components: { TopupLoader },
  mixins: [TopupBackMixin],
  computed: {
    ...mapState({
      isLoading: state => state.energy.loading,
      status: state => state.energy.topupStatus
    })
  },
  methods: {
    ...mapActions([
      'getEnergyTopupStatus'
    ]),
    goToTopup () {
      this.$router.push(ROUTING.stepForm)
    },
    isTopupOk () {
      return this.status === TOPUP_PAYMENT_STATUS.ok
    },
    isTopupError () {
      return this.status === TOPUP_PAYMENT_STATUS.error
    },
    isTopupWaitingForPayment () {
      return this.status === TOPUP_PAYMENT_STATUS.wait
    },
    getTopupStatus () {
      let data = {
        serviceId: this.$route.query.ServiceID,
        orderId: this.$route.query.OrderID,
        hash: this.$route.query.Hash
      }
      this.getEnergyTopupStatus(data)
        .then(() => {
          if (this.isTopupWaitingForPayment()) {
            setTimeout(this.getTopupStatus, 1000)
          }
        })
        .catch(error => {
          Raven.captureMessage('PGE getTopupStatus error', {
            extra: error
          })
        })
    }
  },
  mounted () {
    // /* global _paq */
    // _paq.push(['trackPageView'])
    this.getTopupStatus()
  }
}
</script>
